module.exports = __webpack_public_path__ + "img/cross-e-commerce.b0f61a3.png";